import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=16e8a6cd&scoped=true&"
import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseTextarea.vue?vue&type=style&index=0&id=16e8a6cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8a6cd",
  null
  
)

export default component.exports